module.exports = {
  NEW: 'new',
  REJECTED: 'rejected', // when the driver has not been identified
  ASSIGNED: 'assigned', // when the driver has been identified and confirmed
  PAID: 'paid', // when the driver paid the charge
};
